import React from 'react';
import FeaturesComponent from '@framework/ui/Pages/Landing/Sections/Features';
import Section from '@framework/ui/Pages/Landing/Sections/Section';
import SectionContainer from '@framework/ui/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@framework/ui/Pages/Landing/Sections/SectionHeader';
import { featuresTabsList } from './tabs';
import styles from './features.module.scss';

interface IProps {
  title: string,
  description: string,
  actionButton: React.ReactNode,
}

const Features = ({ title, description, actionButton }: IProps) => (
  <Section padding="top" className={ styles.sectionWrapper } dataTest="featuresSection">
    <SectionContainer>
      <SectionHeader
        title={ title }
        description={ description }
        maxWidth={ 900 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <FeaturesComponent
        actionButton={ actionButton }
        tabsList={ featuresTabsList }
        autoplay
      />
    </SectionContainer>
  </Section>
);

export default Features;
